module.exports = __webpack_public_path__ + "static/media/print-be-your-car.cd2a006d.jpg";